import { Outlet } from 'react-router';
import { Suspense } from 'react';
import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/layout/Footer';
import { ScrollToTop } from '@/components/layout/ScrollToTop';
import { LenisProvider } from '@/lib/lenis';

export function RootLayout() {
  return (
    <LenisProvider>
      <ScrollToTop />
      <div className="flex min-h-screen flex-col bg-brand-cream text-brand-ink">
        <Header />
        <main className="flex-1 pt-[88px] md:pt-[112px]">
          {/* Réserve la hauteur pendant le chargement d'une page à la demande
              pour éviter tout saut de mise en page. */}
          <Suspense fallback={<div className="min-h-[70vh]" aria-hidden />}>
            <Outlet />
          </Suspense>
        </main>
        <Footer />
      </div>
    </LenisProvider>
  );
}
